import { useIntl } from 'react-intl';
import { StyledSelect } from 'styles/overrides';
import _ from 'lodash';
import { useDistricts } from 'api/locationApi';
import { filterOptions } from 'utils/formatUtils';

export default function DistrictSelector({
  provinceId,
  onChange,
  value,
  ...restProps
}) {
  const intl = useIntl();

  const { data = [], isLoading } = useDistricts({
    provinceId,
    options: {
      select: (response) =>
        _.map(response, ({ id, name, prefix }) => ({
          label: `${prefix} ${name}`,
          value: id.toString(),
        })),
    },
  });

  return (
    <StyledSelect
      options={data}
      loading={isLoading}
      placeholder={intl.formatMessage({ id: 'common.placeholder.district' })}
      showSearch
      optionFilterProp="label"
      filterOption={filterOptions}
      {...restProps}
      onChange={onChange}
      value={value}
    />
  );
}
